import { UseFormRegisterReturn } from 'react-hook-form';
import { Box, NativeSelect, NativeSelectFieldProps } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

type SelectOption = {
  value: string | number;
  label: string;
};

type SelectFieldProps = FieldWrapperPassThroughProps & {
  className?: string;
  placeholder: string;
  options: SelectOption[];
  registration: Partial<UseFormRegisterReturn>;
  leftElement?: React.ReactNode;
  onChange?: React.ChangeEventHandler<HTMLSelectElement> | undefined;
  defaultValue?: NativeSelectFieldProps['defaultValue'];
  disabled?: boolean;
};

export const SelectField = ({
  className,
  label,
  registration,
  error,
  placeholder,
  options,
  leftElement,
  onChange,
  defaultValue,
  disabled = false,
}: SelectFieldProps): ReactElement => {
  const { onChange: registerOnChange, ...registrationFieldProps } = registration;

  return (
    <FieldWrapper label={label} error={error}>
      <NativeSelect.Root
        disabled={disabled}
        css={{
          '&:focus-within > .left-element > svg': {
            color: 'icon.accent',
          },
        }}
      >
        <NativeSelect.Field
          placeholder={placeholder}
          className={className}
          defaultValue={defaultValue}
          disabled={disabled}
          {...registrationFieldProps}
          pl={leftElement ? '42px' : undefined}
          onChange={(event) => {
            registerOnChange?.(event);
            onChange?.(event);
          }}
        >
          {options.map((option) => (
            <option value={option.value} key={option.value}>
              {option.label}
            </option>
          ))}
        </NativeSelect.Field>
        {leftElement && (
          <Box
            w="40px"
            h="42px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            position="absolute"
            left="0"
            className="left-element"
          >
            {leftElement}
          </Box>
        )}
        <NativeSelect.Indicator />
      </NativeSelect.Root>
    </FieldWrapper>
  );
};
